module.exports = __webpack_public_path__ + "img/default-placeholder.a36832a1.png";